export default __webpack_public_path__ + "static/media/CashIsKing_159x150.20225d4c.png";